export default __webpack_public_path__ + "static/media/step-3.50e17375.svg";